import React from "react";

import { GridItem, GridRow } from "commons/ui/Grid";
import Select from "commons/ui/input/Select";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { ProjectsListHook } from "hooks/list/useProjectsList";
import useProjectCategories from "hooks/useProjectCategories";

function ProjectsExtraFilters({ projectsListHook }: { projectsListHook: ProjectsListHook }) {
    const { staticFilterHook } = projectsListHook;

    const { setValue, form } = staticFilterHook;

    const projectCategories = useProjectCategories();

    return (
        <GridRow>
            <GridItem className={"col-xs-12-4"}>
                <Select
                    label={"Categoria"}
                    options={projectCategories}
                    setValue={setValue}
                    value={form.category}
                    path={"category"}
                    showPlaceholder
                    filterInput
                />
            </GridItem>

            <GridItem className={"col-xs-12-4"}>
                <Select
                    label={"Area pubblica"}
                    options={[
                        { label: "Tutti", value: "" },
                        { label: "Visibile", value: true },
                        { label: "Non visibile", value: false },
                    ]}
                    setValue={setValue}
                    value={form.enabled}
                    path={"enabled"}
                    showPlaceholder
                    filterInput
                />
            </GridItem>
        </GridRow>
    );
}

function ProjectsTableFilters({ projectsListHook }: { projectsListHook: ProjectsListHook }) {
    const { onSearchFilterChange, filterSearchHook, staticFilterHook } = projectsListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;

    const { clearStaticFilters } = staticFilterHook;

    const clearAllFilters = React.useCallback(() => {
        clearFilters();
        clearStaticFilters();
    }, [clearStaticFilters, clearFilters]);

    return (
        <FiltersContainer
            applyFilters={applyFilters}
            clearFilters={clearAllFilters}
            extraFilters={<ProjectsExtraFilters projectsListHook={projectsListHook} />}
            openDefault={staticFilterHook.filters.length > 0}
        >
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.title}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default ProjectsTableFilters;
